import { Grid } from "@mui/material";
import React, { ReactElement, useEffect } from "react";

import { fieldContainerSelectorID } from "../../Constants";
import { getContainerStyles, getMainStyles } from "./View.style";

export interface ViewProps {
  isQuestionnaire?: boolean;
  children: ReactElement;
  className?: string;
  header?: ReactElement;
  route?: string | number;
}

export const View: React.FC<ViewProps> = ({
  route = null,
  isQuestionnaire = false,
  children,
  className,
  header = null,
}) => {
  useEffect(() => {
    /*
     * This is an important accessibility feature!
     * As a user navigates through the questionnaire using assistive technology or using keyboard navigation,
     * focus will be placed at the top of the main content so that the user can continue navigating through
     * the questionnaire without having to tab backwards to return to the top of the form.
     */
    if (route === null) {
      return;
    }

    const elements = document.getElementsByTagName("main");
    if (elements.length) {
      const main = elements[0];
      main.setAttribute("tabindex", "0");
      main.focus();
      main.removeAttribute("tabindex");
      window.scroll(0, 0);
    }

    // scroll question options to the top on question change
    const fieldContainer = document.getElementById(fieldContainerSelectorID);
    if (fieldContainer) {
      fieldContainer.scroll(0, 0);
    }
  }, [route]);

  return (
    <Grid sx={getContainerStyles(isQuestionnaire)}>
      {header}
      <Grid
        component="main"
        container
        direction="column"
        alignSelf="center"
        sx={getMainStyles(isQuestionnaire)}
        className={className}
      >
        {children}
      </Grid>
    </Grid>
  );
};
